import { useLocation } from "react-router-dom"
import config from "../../config"
import { Helmet } from "react-helmet-async"
import { useTranslation } from "react-i18next"

const matchPathWithParams = (pathPattern, currentPath) => {
    const pattern = pathPattern
        .replace(/:[^\s/]+/g, '([^/]+)')
        .replace(/\//g, '\\/')
    const regex = new RegExp(`^${pattern}$`)
    return regex.test(currentPath)
}

const MetaUpdater = ({overrideTitle}) => {
  const {t} = useTranslation()
    const location = useLocation()
    const currentPath = location.pathname

    const matchedEntry = Object.entries(config.pageMeta).find(([pattern]) =>
        matchPathWithParams(pattern, currentPath)
    )
    const meta = matchedEntry?.[1]

    const title = overrideTitle || (meta ? meta.title : "page_default_title")

    return (
        <Helmet>
            <title>{t(title)}</title>
        </Helmet>
    )
}

export default MetaUpdater
